import type { PointerEvent } from "react";

import type { ScrubDirection } from "@/lib/timeline/playback";

export function scrubHoldHandlers(
  direction: -1 | 1,
  onScrub: (direction: ScrubDirection) => void,
) {
  const start = (event: PointerEvent<HTMLButtonElement>): void => {
    onScrub(direction);
    try {
      event.currentTarget.setPointerCapture(event.pointerId);
    } catch {
      // Capture is best-effort; release still clears scrub.
    }
  };
  const stop = (): void => {
    onScrub(0);
  };
  return {
    onPointerDown: start,
    onPointerUp: stop,
    onPointerCancel: stop,
    onLostPointerCapture: stop,
  };
}
